import BasicLiveChannel from './BasicLiveChannel'

class LiveCollectionChannel extends BasicLiveChannel {
  onDataChanged(socketData) {
    for (const serverModelName in socketData) {
      const updateActions = socketData[serverModelName]
      for (const actionName in updateActions) {
        const actionItems = updateActions[actionName]
        this.emit(`${ actionName }:${ serverModelName }`, actionItems)
      }
      // this.emit(`live_update_complete:${ serverModelName }`)
    }
    return
  }
}

export default LiveCollectionChannel
